var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStudioLogoIcon = function SvgStudioLogoIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.288 0A.288.288 0 0 0 0 .288v20.424c0 .16.129.288.288.288h20.424a.288.288 0 0 0 .288-.288V.288A.288.288 0 0 0 20.712 0H.288ZM10.5 17.836a7.336 7.336 0 1 0 0-14.672 7.336 7.336 0 0 0 0 14.672Z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#000"
  })));
};
export default SvgStudioLogoIcon;